<script lang="ts" setup>
import { classNames } from '@afinius/utilities/class-names';

interface Props {
  hasReducedSpacing?: boolean;
}

defineProps<Props>();
</script>

<template>
  <div class="dropdown-header" :class="classNames({ hasReducedSpacing })">
    <slot />
  </div>
</template>

<style lang="scss">
@use './DropdownHeader.scss';
</style>
